// extracted by mini-css-extract-plugin
module.exports = {"container":"SiteLoading-module--container--2l4Qb","spinner":"SiteLoading-module--spinner--1ab86","skBouncedelay":"SiteLoading-module--sk-bouncedelay--2Hrt4"};